import { DocumentType } from '@/plugins/api'
import { chunk } from 'lodash'
export default {
  namespaced: true,
  state: {
    documentTypes: [],
    searchParams: {}
  },
  actions: {
    async fetchDocumentTypes({ commit, state }, params) {
      let searchParams = { ...state.searchParams }
      if (params) {
        const { createdTeacher, ...options } = params
        searchParams = { ...options }
      }
      const documentTypes = await DocumentType.fetchDoctypes(searchParams)
      commit('changeState', { documentTypes, searchParams })
    },
    async createDocumentType({ commit, state }, data) {
      data = { ...data, index: state.documentTypes.length + 1 }
      const t = await DocumentType.create(data)
      commit('createDocumentType', t)
      return t
    },
    async removeDocumentType({ commit }, documentType) {
      await DocumentType.remove(documentType.id)
      // update index
      const afterItems = await DocumentType.fetch({
        index_gt: documentType.index,
        _limit: -1
      })
      const groups = chunk(afterItems, 5)
      for (const subTypes of groups) {
        const promises = subTypes.map(type => DocumentType.update(type.id, { index: type.index - 1 }))
        await Promise.all(promises)
      }
      commit('removeDocumentType', documentType.id)
    },
    async updateDocumentType({ dispatch }, { id, ...type }) {
      await DocumentType.update(id, type)
      dispatch('fetchDocumentTypes')
    },
    async updateIndex(_, options) {
      const { itemMoving, newIndex } = options
      await DocumentType.updateIndex(itemMoving.id, { newIndex })
    }
  },
  mutations: {
    updateDocumentType(state, documentType) {
      state.documentTypes = state.documentTypes.map(g => {
        if (documentType.id === g.id) return documentType
        else return g
      })
    },
    createDocumentType(state, documentType) {
      state.documentTypes = [{ ...documentType, fileNo: '0' }, ...state.documentTypes]
    },
    removeDocumentType(state, id) {
      state.documentTypes = state.documentTypes.filter(documentType => documentType.id !== id)
    }
  }
}
